import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { useForm } from "react-hook-form";
import _ from "lodash/fp";
import passwordLable from "../labels/reset_password_en.json";
import "../../styles/login.css";
import "../../styles/reset_password.css";
import { resetPassword } from "../actions/loginAction";
import { emailRegex, mobileRegex } from "../../common/constants/regex";

export default function ResetPassword(props) {
  const { register, handleSubmit, errors, watch, clearErrors } = useForm({
    mode: "onChange",
  });

  const dispatch = useDispatch();

  const [confirmPasswordFlag, setConfirmPasswordFlag] = useState(false);
  const confirmpassword = watch("confirm_password");
  const [passwordFlag, setPasswordFlag] = useState(false);
  const [currntPasswordFlag, setCurrentPasswordFlag] = useState(true);
  const [OldPasswordFlag, setOldPasswordFlag] = useState(false);

  const checkValidity = (evt) => {
    if (evt.target.value === watch("password")) {
      setConfirmPasswordFlag(false);
    } else {
      setConfirmPasswordFlag(true);
    }

    if (evt.target.value === watch("confirm_password")) {
      setPasswordFlag(false);
    } else {
      setPasswordFlag(true);
    }
  };

  const checkValidityForSamepasswaord = (evt) => {
    checkValidity(evt);
    if (evt.target.value === watch("currentpassword")) {
      setCurrentPasswordFlag(false);
    } else {
      setCurrentPasswordFlag(true);
    }
  };

  const checkValidityForNotSamepasswaord = (evt) => {
    if (evt.target.value === watch("password")) {
      setOldPasswordFlag(true);
    } else {
      setOldPasswordFlag(false);
    }
  };

  const onSubmit = (data) => {
    const userName =
      data.usertype === "email"
        ? data.emailId.trim().toLowerCase()
        : data.mobileNo;
    if (!confirmPasswordFlag && currntPasswordFlag && !passwordFlag) {
      let reqBody = {
        username: userName,
        oldPassword: data.currentpassword,
        newPassword: data.password,
      };

      dispatch(resetPassword(reqBody, props));
    }
  };

  const handleCancel = () => {
    clearErrors();
  };
  return (
    <form onSubmit={handleSubmit(onSubmit)} className="row mt-50 mb-50">
      <div className="col-md-3"></div>
      <div className="col-md-6 bgColor-fff p-30 pl-100 pr-100">
        <div className="text-center">
          <span className="bold-text">{passwordLable.Reset_Password}</span>
        </div>
        <div className="row">
          <div className="col-md-12 text-center m-10">
            <label className="pos-relative tp-12 rt-30 mr-10">
              <input
                type="radio"
                className="radio"
                name="usertype"
                value="email"
                ref={register({ required: false })}
              />
              &nbsp;{passwordLable.Email_ID}
            </label>
            <label className="pos-relative tp-12 rt-30 mr-10">
              <input
                type="radio"
                className="radio"
                name="usertype"
                value="mobile"
                ref={register({ required: false })}
              />
              &nbsp;{passwordLable.Mobile_Number}
            </label>
          </div>
        </div>
        {watch("usertype") === "email" ? (
          <div>
            <label className="LeftText">
              {passwordLable.Email_ID}
              <span className="errorText">*</span>
            </label>
            <div className="input-group">
              <input
                className="form-control"
                id="registrationFormControlInput1"
                type="text"
                name="emailId"
                ref={register({ required: true, pattern: emailRegex })}
              />
            </div>
            {_.get("emailId.type", errors) === "required" && (
              <p className="errorText">
                {passwordLable.validationMessage.ONLY_EMAIL_REQUIRED}
              </p>
            )}
            {_.get("emailId.type", errors) === "pattern" && (
              <p className="errorText">
                {passwordLable.validationMessage.EMAIL_PATTERN}
              </p>
            )}
          </div>
        ) : (
          ""
        )}
        {watch("usertype") === "mobile" ? (
          <div>
            <label className="LeftText">
              {passwordLable.Mobile_Number}
              <span className="errorText">*</span>
            </label>
            <div className="input-group">
              <input
                className="form-control"
                id="registrationFormControlInput1"
                type="text"
                name="mobileNo"
                ref={register({ required: true, pattern: mobileRegex })}
              />
            </div>
            {_.get("mobileNo.type", errors) === "required" && (
              <p className="errorText">
                {passwordLable.validationMessage.MOBILE_REQ}
              </p>
            )}
            {_.get("mobileNo.type", errors) === "pattern" && (
              <p className="errorText">
                {passwordLable.validationMessage.MOBILE_PATTERN}
              </p>
            )}
          </div>
        ) : (
          ""
        )}
        <div>
          <label className="LeftText">
            {passwordLable.ENTER_FIRST_TIME_PWD}
            <span className="errorText">*</span>
          </label>

          <input
            className="form-control"
            type="password"
            name="currentpassword"
            ref={register({ required: true })}
            onChange={checkValidityForNotSamepasswaord}
          />
          {_.get("currentpassword.type", errors) === "required" && (
            <p className="errorText">
              {passwordLable.validationMessage.PASSWORD_REQUIRED}
            </p>
          )}
        </div>
        <div>
          <label className="LeftText">
            {passwordLable.PASSWORD}
            <span className="errorText">*</span>
          </label>
          <input
            className="form-control"
            type="password"
            name="password"
            ref={register({
              required: true,
              minLength: 8,
              maxLength: 15,
              validate: {
                oneCapitalLetter: (value) =>
                  /(?![.\n])(?=.*[A-Z]).*$/.test(value),
                oneNumber: (value) => /((?=.*\d)|(?=.*\W+)).*$/.test(value),
                oneSpecialCharacter: (value) =>
                  /(?=.*[!@#%&])(?=.{8,}$)/.test(value),
              },
            })}
            onChange={checkValidityForSamepasswaord}
          />
          {_.get("password.type", errors) === "required" && (
            <p className="errorText">
              {passwordLable.validationMessage.PASSWORD_REQ}
            </p>
          )}
          {_.get("password.type", errors) === "minLength" && (
            <p className="errorText">
              {passwordLable.validationMessage.MIN_LENGTH_VALIDATION}
            </p>
          )}
          {_.get("password.type", errors) === "maxLength" && (
            <p className="errorText">
              {passwordLable.validationMessage.MAX_LENGTH_VALIDATION}
            </p>
          )}
          {errors.password?.type === "oneCapitalLetter" && (
            <p className="errorText">
              {passwordLable.validationMessage.MIN_ONE_CAPITAL_LETTER}
            </p>
          )}
          {errors.password?.type === "oneNumber" && (
            <p className="errorText">
              {passwordLable.validationMessage.MIN_ONE_NUMBER}
            </p>
          )}
          {errors.password?.type === "oneSpecialCharacter" && (
            <p className="errorText">
              {passwordLable.validationMessage.MIN_ONE_SPECIAL_CHAR}
            </p>
          )}
          {errors.password && (
            <p className="errorText">{errors.password.message}</p>
          )}
          {OldPasswordFlag && _.get("password.type", errors) !== "required" ? (
            <p className="errorText">
              {passwordLable.Old_password_New_password_not_same}
            </p>
          ) : (
            ""
          )}
          {passwordFlag &&
          confirmpassword &&
          _.get("password.type", errors) !== "required" ? (
            <p className="errorText">
              {passwordLable.New_password_Confirm_password_same}
            </p>
          ) : (
            ""
          )}
        </div>
        <div>
          <label className="LeftText">
            {passwordLable.CONFIRM_PASSWORD}
            <span className="errorText">*</span>
          </label>

          <input
            className="form-control"
            id="registrationFormControlInput1"
            type="password"
            name="confirm_password"
            ref={register({ required: true })}
            onChange={checkValidity}
          />
          {_.get("confirm_password.type", errors) === "required" && (
            <p className="errorText">
              {passwordLable.validationMessage.CONFIRM_PASSWORD_REQUIRED}
            </p>
          )}
          {confirmPasswordFlag &&
          _.get("confirm_password.type", errors) !== "required" ? (
            <p className="errorText">
              {passwordLable.New_password_Confirm_password_same}
            </p>
          ) : (
            ""
          )}
        </div>

        <div className="buttonAlign">
          <button type="submit" className="btn btn-primary mr-5">
            {passwordLable.RESET}
          </button>
          <button
            type="button"
            className="btn btn-primary"
            onClick={handleCancel}
          >
            {passwordLable.CANCEL}
          </button>
        </div>
      </div>
    </form>
  );
}
